import { ITopicResource } from "../../topics";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IReflectiveAnalysisList, ReflectiveAnalysisType } from "../types";

export interface IReflectiveAnalysisListQueryParameters extends IPaginateable, IOrderable<"createdAt"> {
    filters?: {
        createdBy?: RelationalFilter<IUserResource>;
        topic?: RelationalFilter<ITopicResource>;
        type?: ReflectiveAnalysisType;
    };
}

export type IReflectiveAnalysisListQueryResult = IReflectiveAnalysisList;

const mapFilters = (filters: IReflectiveAnalysisListQueryParameters["filters"]) => {
    const { createdBy, topic, type } = filters ?? {};

    return {
        "createdBy.uuid": mapRelationalFilter(createdBy),
        "individualAssignment.uuid": mapRelationalFilter(topic),
        type,
    };
};

export const reflectiveAnalysisListQuery: IApiQueryFunction<IReflectiveAnalysisListQueryParameters> = ({
    filters,
    order,
    pagination,
}) => {
    return {
        method: "GET",
        url: `/reflective_analyses${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useReflectiveAnalysisListQuery = createApiQueryHook<
    IReflectiveAnalysisListQueryParameters,
    IReflectiveAnalysisListQueryResult
>(reflectiveAnalysisListQuery);
